import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const P12B = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.1px;
  ${customTextColor}
`;
